import React, { cloneElement, ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import { ButtonProps as MuiButtonProps } from '@mui/material/Button'

import { ReactComponent as NewProject } from '@mike/mike-shared-frontend/media/icons/NewProject'
import { iconStyle, StyledButtonSecondaryBorder } from './iconStyles'

type IconButtonType = {
  icon?: ReactElement
  messageId: string
}

const IconButton = (props: MuiButtonProps & IconButtonType) => {
  const { icon, messageId, ...buttonProps } = props
  const iconComponent = icon || <NewProject />
  const iconElement = cloneElement(iconComponent, {
    className: iconStyle
  })
  return (
    <StyledButtonSecondaryBorder {...buttonProps}>
      {iconElement}
      <FormattedMessage id={messageId} />
    </StyledButtonSecondaryBorder>
  )
}

export default IconButton
